import { render } from "./TogglableCaretHeader.vue?vue&type=template&id=0dc431ca"
import script from "./TogglableCaretHeader.vue?vue&type=script&lang=js"
export * from "./TogglableCaretHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__